import { Box, Button, Checkbox, DialogActions, DialogContent, DialogTitle, Drawer, FormControl, FormLabel, Grid, Input, ModalClose } from "@mui/joy";
import React from "react";
import { Building } from "../Pages/BuildingList";

interface BuildingDialogProps {
	open: boolean;
	close: Function;
	bld?: Building;
}

export default function BuildingDialog(props: BuildingDialogProps) {
	const [open, setOpen] = React.useState(false);
	const [building, setBuilding] = React.useState({
		Name: "",
		ID: "",
		Address1: "",
		Address2: "",
		City: "",
		State: "",
		Zip: "",
		Active: true,
	} as Building
		
	);

	React.useEffect(() => {
		setOpen(props.open);
		setBuilding(props.bld ?? ({
			Name: "",
			ID: "",
			Address1: "",
			Address2: "",
			City: "",
			State: "",
			Zip: "",
			Active: true,
		} as Building));
	}, [props.open, props.bld]);

	const close = (bid: string) => {
		props.close(bid);
	};

	const sizes = {
		xs: 12,
		sm: 6,
		md: 4,
		lg: 3,
	};

	const save = () => {
		fetch("Building/SaveBuildingData", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({
				buildings_id: building.ID ?? "",
				building_name: building.Name,
				address1: building.Address1,
				address2: building.Address2,
				city: building.City,
				state: building.State,
				zip: building.Zip,
				is_active: building.Active,
			}),
		})
			.then((x) => x.text())
			.then((x) => {
				console.log(x);
				close(x);
			});
	};

	return (
		<>
			<Drawer anchor="right" open={open} size="lg">
				<ModalClose onClick={() => close("")} />
				<DialogTitle>{building.ID ? "Edit Building" : "Add Building"}</DialogTitle>
				<DialogContent sx={{ padding: 2 }}>
					<Grid container spacing={2} sx={{ overflowX: "hidden" }}>
						<Grid xs={12}>
							<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Building Information</FormLabel>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Name</FormLabel>
								<Input
									value={building.Name}
									onChange={(event) => {
										setBuilding({ ...building, Name: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Active?</FormLabel>
								<Checkbox checked={building.Active} onChange={(event) => setBuilding({ ...building, Active: event.target.checked })} />
							</FormControl>
						</Grid>

						<Grid xs={12}>
							<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Address Information</FormLabel>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Street Address 1</FormLabel>
								<Input
									value={building.Address1}
									onChange={(event) => {
										setBuilding({ ...building, Address1: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Street Address 2</FormLabel>
								<Input
									value={building.Address2}
									onChange={(event) => {
										setBuilding({ ...building, Address2: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>City</FormLabel>
								<Input
									value={building.City}
									onChange={(event) => {
										setBuilding({ ...building, City: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>State</FormLabel>
								<Input
									value={building.State}
									onChange={(event) => {
										setBuilding({ ...building, State: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Zip</FormLabel>
								<Input
									value={building.Zip}
									onChange={(event) => {
										setBuilding({ ...building, Zip: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Box sx={{ padding: 2 }}>
						<Button size="lg" color="primary" onClick={() => close("")} sx={{ mx: 1 }}>
							Close
						</Button>
						<Button size="lg" color="primary" onClick={save} sx={{ mx: 1 }}>
							Save
						</Button>
					</Box>
				</DialogActions>
			</Drawer>
		</>
	);
}
